// extracted by mini-css-extract-plugin
export default {"footerContainer":"footer_footerContainer__--Xv7","title":"footer_title__NO+Fr","notice":"footer_notice__hLrbl","icons":"footer_icons__00kbw"};